<template>
  <v-app id="inspire">
    <Header v-model="expandOnHover"></Header>
    <Sidebar :expand-on-hover.sync="expandOnHover"></Sidebar>
    <v-main>
      <v-container class="fill-height mb-2" fluid>
        <transition name="fade">
          <router-view />
        </transition>
      </v-container>
    </v-main>

    <Footer></Footer>

    <create-general-memo-modal></create-general-memo-modal>
    <create-x-letter-modal></create-x-letter-modal>
    <create-permit-memo-modal></create-permit-memo-modal>
    <create-incoming-letter-modal></create-incoming-letter-modal>
    <create-crash-letter-modal></create-crash-letter-modal>
    <help-group-recipient-dialog></help-group-recipient-dialog>
    <create-subholding-modal></create-subholding-modal>
    <create-xnusantara-modal></create-xnusantara-modal>
    <create-sppd-modal></create-sppd-modal>
    <edit-sppd-modal></edit-sppd-modal>

    <v-snackbar
      v-model="appSnackbarState"
      :multi-line="true"
      :top="true"
      :centered="true"
      :timeout="5000"
    >
      <p v-html="$t(appSnackbar.title)" class="snackbar--header"></p>
      <p v-html="$t(appSnackbar.message)"></p>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="appSnackbarState = false"
        >
          {{ $t("button.close") }}
        </v-btn>
      </template>
    </v-snackbar>

    <v-btn
      v-scroll="onScroll"
      v-show="fab"
      fab
      dark
      fixed
      bottom
      right
      color="primary"
      @click="toTop"
    >
      <v-icon>{{iconArrowUp}}</v-icon>
    </v-btn>
  </v-app>
</template>

<script>
import helpGroupRecipientDialog from "../components/commonComponents/HelpGroupRecipientModal";
import Header from "./header/Header";
import Sidebar from "./sidebar/Sidebar";
import Footer from "./footer/Footer";
// import createGeneralMemoModal from "@/components/commonComponents/CreateGeneralMemoModal";
// import createXLetterModal from "@/components/commonComponents/CreateXLetterModal";
// import createPermitMemoModal from "@/components/commonComponents/CreatePermitMemoModal";
// import createIncomingLetterModal from "@/components/commonComponents/CreateIncomingLetterModal";
import { mapState, mapMutations } from "vuex";
import { mdiChevronUp } from '@mdi/js';
export default {
  name: "Layout",

  components: {
    Header,
    Sidebar,
    Footer,
    'create-general-memo-modal': () => import('@/components/commonComponents/CreateGeneralMemoModal'),
    'create-permit-memo-modal': () => import('@/components/commonComponents/CreatePermitMemoModal'),
    'create-x-letter-modal': () => import('@/components/commonComponents/CreateXLetterModal'),
    'create-incoming-letter-modal': () => import('@/components/commonComponents/CreateIncomingLetterModal'),
    'create-crash-letter-modal': () => import('@/components/commonComponents/CreateCrashLetterModal.vue'),
    'create-subholding-modal': () => import('@/components/commonComponents/CreateSubholdingMemoModal'),
    'create-xnusantara-modal': () => import('@/components/commonComponents/CreateXNusantaraModal'),
    'create-sppd-modal': () => import('@/components/commonComponents/CreateSppdModal.vue'),
    'edit-sppd-modal': () => import('@/components/commonComponents/EditSppdModal.vue'),
    helpGroupRecipientDialog,
  },
  data: () => ({
    iconArrowUp: mdiChevronUp,
    fab: false
  }),
  computed: {
    ...mapState([
      "Customizer_drawer",
      "loaderMessage",
      "appMessageBox",
      "appSnackbar",
    ]),
    ...mapState("draft", ["editGeneralMemo", "editPermitMemo","editXLetter","editIncomingMemo","editSubholdingMemo"]),
    appSnackbarState: {
      get() {
        return this.$store.state.appSnackbar.show;
      },
      set(val) {
        this.$store.commit("SET_APP_SNACKBAR_STATE", val);
      },
    },
    expandOnHover: {
      get() {
        return this.$store.state.expandOnHover;
      },
      set(val) {
        this.$store.commit("SET_EXPAND_ON_HOVER", val);
      },
    },
  },

  methods: {
    ...mapMutations({
      setCustomizerDrawer: "SET_CUSTOMIZER_DRAWER",
    }),
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop () {
      this.$vuetify.goTo(0)
    }
  },
};
</script>
